import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { FormGroup, FormControl } from "react-bootstrap";

const UploadDocument = ({ task }) => {
  return (
    <Formik
      initialValues={{ document: "" }}
      onSubmit={(values) => {
        const formData = new FormData();
        formData.append("task[id]", task.id);
        !task.cpr.document.url && formData.append("task[document]", values.document);
        values.document && formData.append("task[sub_status_list_id]", 2);

        return task.formHandler(formData);
      }}
    >
      {({ values, setFieldValue, setTouched, errors }) => {
        return (
          <Form>
            <label>Attach results/visit summary (if available)</label>
            <FormGroup controlId="formFile" className="mb-3">
              <FormControl
                type="file"
                onChange={(e) => setFieldValue("document", e.target.files[0])}
              />
            </FormGroup>
            <button className="check" type="submit">
              Submit Results/Visit Summary
            </button>
          </Form>
        );
      }}
    </Formik>
  );
};

export default UploadDocument;
